import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'temperature',
  standalone: true,
})
export class TemperaturePipe implements PipeTransform {
  transform(temp: string): string {
    if (!temp) return ''
    const temperature = Math.round(parseFloat(temp))
    return `${temperature}°C`
  }
}
